import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import Frame from './Frame';

const characterSkeletonCSS = css`
  display: flex;
  align-items: center;
  padding: ${Spacing.small}px ${Spacing.medium}px;
  gap: ${Spacing.medium}px;
  margin-top: ${Spacing.small}px;

  .avatar div:nth-of-type(1) {
    width: 44px;
    height: 44px;
    border-radius: 50px;
  }

  .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${Spacing.xxsmall}px;
  }

  .info div:nth-of-type(1) {
    width: 30%;
    height: 18px;
  }

  .info div:nth-of-type(2) {
    width: 80%;
    height: 12px;
  }
`;

const CharacterSkeleton = () => {
  return (
    <div css={characterSkeletonCSS}>
      <div className="avatar">
        <Frame />
      </div>
      <div className="info">
        <Frame />
        <Frame />
      </div>
    </div>
  );
};

export default CharacterSkeleton;
